export const IconSavedPenal = () => {
  return (
    <svg
      className="w-full"
      enableBackground="new 0 0 25 25"
      viewBox="0 0 25 25"
      x="0px"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      y="0px"
    >
      <g>
        <path
          d="M12.6,1.1L12.6,1.1c6.4,0,11.5,5.1,11.5,11.5l0,0c0,6.4-5.1,11.5-11.5,11.5
        l0,0C6.3,24.1,1.1,19,1.1,12.6l0,0C1.1,6.3,6.3,1.1,12.6,1.1z"
          fill="#E3EAFF"
        />
        <path
          d="M12.6,1.8L12.6,1.8
        c6,0,10.8,4.8,10.8,10.8l0,0c0,6-4.8,10.8-10.8,10.8l0,0c-6,0-10.8-4.8-10.8-10.8l0,0C1.8,6.7,6.7,1.8,12.6,1.8z"
          fill="none"
          stroke="#E3EAFF"
          strokeWidth="1.4133"
        />
      </g>
      <path
        d="M20.1,12.4c-0.1-0.1-0.3-0.1-0.4,0L15.2,17c-0.7,0.7-1.7,1.2-2.7,1.4c-0.1,0-0.1,0-0.1,0.1L10,20.8
      c-0.1,0.1-0.1,0.3,0,0.4c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2-0.1l2.3-2.3c1.1-0.2,2.1-0.8,2.9-1.5l4.5-4.5
      C20.2,12.7,20.2,12.5,20.1,12.4z"
        fill="#3366FF"
      />
      <path
        d="M14.8,16.6l4.5-4.5c0.2-0.2,0.3-0.5,0.3-0.8c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.4-0.3-0.6-0.3l0.7-0.7
      c0.4-0.4,0.4-1.2,0-1.6c-0.2-0.2-0.3-0.3-0.6-0.3l0.2-0.2c0.2-0.2,0.3-0.5,0.3-0.8c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.3-0.8-0.3
      c-0.3,0-0.6,0.1-0.8,0.3L17.3,6c0-0.2-0.1-0.4-0.3-0.6c-0.2-0.2-0.5-0.3-0.8-0.3c-0.3,0-0.6,0.1-0.8,0.3l-2.2,2.2
      c0-0.2-0.1-0.4-0.3-0.6c-0.2-0.2-0.5-0.3-0.8-0.3c-0.3,0-0.6,0.1-0.8,0.3l-3.1,3.1c-0.7,0.7-1.2,1.6-1.3,2.7l-2.5,2.5
      c-0.4,0.4-0.4,1.1,0,1.6l3.6,3.6c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3l2.5-2.5C13.1,17.8,14.1,17.3,14.8,16.6z M11.8,17.5
      l-2.6,2.6c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.3-0.1-0.4-0.2l0,0l1.6-1.6c0.1-0.1,0.1-0.3,0-0.4c-0.1-0.1-0.3-0.1-0.4,0l-1.6,1.6
      l-0.4-0.4L8.8,18c0.1-0.1,0.1-0.3,0-0.4c-0.1-0.1-0.3-0.1-0.4,0l-1.2,1.2l-0.4-0.4l1.1-1.1C8,17.2,8,17.1,7.9,17
      c-0.1-0.1-0.3-0.1-0.4,0l-1.1,1.1L6,17.6l1.2-1.2c0.1-0.1,0.1-0.3,0-0.4C7.1,16,7,16,6.9,16.1l-1.2,1.2l-0.4-0.4l1.6-1.6
      c0.1-0.1,0.1-0.3,0-0.4c-0.1-0.1-0.3-0.1-0.4,0l-1.6,1.6l0,0c-0.2-0.2-0.2-0.6,0-0.8L7.4,13c0,0,0.1-0.1,0.1-0.2
      C7.6,12,8,11.1,8.6,10.4l3.1-3.1c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.5,0.2c0.2,0.2,0.2,0.6,0,0.9l0,0c0,0-2.5,2.5-2.5,2.5
      c-0.1,0.1-0.1,0.3,0,0.4c0.9,0.9,0.9,2.5,0,3.4c-0.1,0.1-0.1,0.3,0,0.4c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2-0.1
      c1.1-1.1,1.2-2.8,0.2-3.9l2.4-2.4c0,0,2.8-2.8,2.8-2.8c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.5,0.2c0.2,0.2,0.2,0.6,0,0.9l0,0
      c0,0-3.9,3.9-3.9,3.9c-0.1,0.1-0.1,0.3,0,0.4c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2-0.1L17,7c0,0,0.9-0.9,0.9-0.9
      C18,6.1,18.1,6,18.3,6c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0,0.2-0.1,0.3-0.2,0.4l-0.9,0.9c0,0-3.9,3.9-3.9,3.9
      c-0.1,0.1-0.1,0.3,0,0.4c0.1,0.1,0.1,0.1,0.2,0.1s0.1,0,0.2-0.1l3.9-3.9c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.4,0.2
      c0.2,0.2,0.2,0.6,0,0.9L18.2,10l-0.3,0.3l-0.1,0.1l-2.6,2.6c-0.1,0.1-0.1,0.3,0,0.4c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2-0.1
      l2.6-2.6c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0,0.2-0.1,0.3-0.2,0.4l-4.5,4.5
      c-0.7,0.7-1.5,1.1-2.5,1.2C11.9,17.4,11.9,17.5,11.8,17.5z"
        fill="#3366FF"
      />
      <path
        d="M10.7,17.4c-0.8-0.2-1.5-0.5-2.1-1.1c-0.6-0.6-1-1.3-1.1-2.1c0-0.1-0.2-0.2-0.3-0.2C7.1,14,7,14.1,7,14.3
      c0.2,0.9,0.6,1.7,1.3,2.3c0.6,0.6,1.5,1.1,2.3,1.3c0,0,0,0,0.1,0c0.1,0,0.2-0.1,0.3-0.2C10.9,17.5,10.9,17.4,10.7,17.4z"
        fill="#3366FF"
      />
    </svg>
  );
};
